export const isAttending = (auctionId, auctionUser) => {
  const attendingIds = auctionUser.MyAuctions.map((auction) => auction.Auction.AuctionId)
  const userAttending = attendingIds.includes(auctionId)

  return userAttending
}